import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Seo from "@/components/Seo";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiErrorDetail } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(name, email, password);
      navigate("/account");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-24">
      <Seo title="Create Account" path="/register" noindex />
      <p className="font-mono-label text-xs text-primary mb-3">Join NC Mycology</p>
      <h1 className="font-display text-4xl font-light mb-8">Create account</h1>
      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        <div>
          <Label className="font-mono-label text-[11px]">Full name</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name" className="mt-2 h-11" />
        </div>
        <div>
          <Label className="font-mono-label text-[11px]">Email</Label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email" className="mt-2 h-11" />
        </div>
        <div>
          <Label className="font-mono-label text-[11px]">Password</Label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="register-password" className="mt-2 h-11" />
        </div>
        {error && <p className="text-destructive text-sm" data-testid="register-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full h-11 rounded-full font-mono-label text-xs" data-testid="register-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create Account"}
        </Button>
      </form>
      <p className="text-sm text-muted-foreground mt-6 text-center">
        Already have an account? <Link to="/login" className="text-primary hover:underline" data-testid="register-to-login">Sign in</Link>
      </p>
    </div>
  );
}
